
import { Col, Row } from "antd";
import NavBarSection from "../../shared/components/nav-bar-section/nav-bar-section.ui";
// import { useEffect } from "react";
// import { useTranslation } from "react-i18next";
import DownloadAppSection from "../../shared/download-section/download-app-section.ui";


function DownloadAppUi() {
    // const { i18n } = useTranslation();
    // useEffect(() => {
    //     i18n.changeLanguage("ar");
    // }, [i18n]);
    return (
        <Row>
            <Col lg={24} md={24} sm={0} xs={0}>
                <NavBarSection isWhite={false} />
            </Col>
            <Col span={24}>
                <DownloadAppSection asPage={true} />
            </Col>
        </Row>
    );
}
export default DownloadAppUi;